import {
  Anchor,
  Group,
  Paper,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import React from 'react';

import { usePartnerConfig, useRequestPlanUpgrade } from '@portals/api/partners';
import { ReactComponent as ArrowRight } from '@portals/icons/linear/arrow-right-1.svg';

import {
  getPricingPlanDisplayName,
  getPricingPlanIcon,
} from '../../../utils/pricing-plan.utils';

export function YourPlan() {
  const partnerConfig = usePartnerConfig();
  const theme = useMantineTheme();
  const requestPlanUpgrade = useRequestPlanUpgrade();

  const PricingPlanIcon = getPricingPlanIcon(partnerConfig?.pricing_plan?.name);
  const pricingPlanDisplayName = getPricingPlanDisplayName(
    partnerConfig?.pricing_plan?.name
  );

  return (
    <Paper withBorder p="xl" radius="md">
      <Stack spacing="xl">
        <Text size="md" color="gray.8">
          Your Plan
        </Text>

        <Group position="apart" align="center" h={48}>
          <Group align="center">
            {PricingPlanIcon ? (
              <PricingPlanIcon
                width={36}
                height={36}
                color={theme.colors.deep_purple_accent[4]}
              />
            ) : null}

            <Text color="blue_gray.8">{pricingPlanDisplayName}</Text>
          </Group>

          {partnerConfig?.pricing_plan?.name === 'enterprise' ? null : (
            <Anchor
              size="sm"
              onClick={() =>
                requestPlanUpgrade.mutate(
                  'Partners > Settings > Plan and Billing > Your Plan > Upgrade'
                )
              }
            >
              <Group spacing="xs" align="center">
                Upgrade
                <ArrowRight height={15} width={15} />
              </Group>
            </Anchor>
          )}
        </Group>
      </Stack>
    </Paper>
  );
}
